import Loader from '../atoms/Loader';

interface AppointmentInfoProps {
	children?: React.ReactNode;
	heading: string;
	isLoading?: boolean;
	onClick?: () => void;
	timeSlotString: string;
	warning?: boolean;
}

export default function AppointmentInfo({ children, heading, isLoading = false, onClick, timeSlotString, warning = false }: AppointmentInfoProps) {
	const classNames = ['booking__appointment-info'];
	if (warning) classNames.push('booking__appointment-info--warning');
	if (onClick) classNames.push('booking__appointment-info--has-callback');

	return (
		<div className={classNames.join(' ')} onClick={onClick}>
			{isLoading && <Loader />}
			{!isLoading ? (
				<>
					<p className="appointment-info__heading">{heading}</p>
					{timeSlotString && <p className="appointment-info__time-slot">{timeSlotString}</p>}
					{children}
				</>
			) : null}
		</div>
	);
}
